import type { CybusCatalogApplication, CybusCatalogServiceConfiguration, CybusCatalogServiceVersionData } from '../../domain'

export interface ConnectwareServicesCatalogService {
    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    fetchCatalogData(parameters: CybusCatalogServiceConfiguration): Promise<CybusCatalogServiceVersionData>

    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    fetchCatalogApplications(): Promise<readonly CybusCatalogApplication[]>

    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    fetchCommissioningFile(application: CybusCatalogApplication): Promise<File>
}
